export const BADGE_VARIANT = {
  DEFAULT: 'default',
  COUNTER: 'counter',
};

export const BADGE_LIMIT = {
  DEFAULT: 99,
};
